import React from 'react'
import {FaLinkedin,FaGithub} from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import {SiLeetcode} from 'react-icons/si'

const SocialLinks = () => {

    const links = [
        {
            id: 1,
            child: (
                <>
                    LinkedIn <FaLinkedin size={30} />
                </>
            ),
            href: 'https://www.linkedin.com/in/himanshu-tanwar-b92b38228/',
            style: 'rounded-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                    GitHub <FaGithub size={30} />
                </>
            ),
            href: 'https://github.com/tanwarhimanshu1603',
        },
        {
            id: 3,
            child: (
                <>
                    Mail <HiOutlineMail size={30} />
                </>
            ),
            href: 'mailto:foo@gmail.com',
        },
        {
            id: 4,
            child: (
                <>
                    LeetCode <SiLeetcode size={30} />
                </>
            ),
            href: 'https://leetcode.com/tanwarhimanshu1603/',
        },
        {
            id: 5,
            child: (
                <>
                    Resume <BsFillPersonLinesFill size={30} />
                </>
            ),
            href: '/Himanshu Tanwar Resume.pdf',
            style: 'rounded-br-md'
        },

    ]

  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
        <ul>

            {links.map(({id,child,href,style})=>(
                <li key={id} className={"flex justify-between ml-[-100px] hover:rounded-md duration-300 hover:ml-[-10px] items-center w-40 h-14 px-4 bg-gradient-to-r from-gray-800 to-gray-500 " + style}>
                   <a href={href} className='flex justify-between items-center w-full text-white' target='_blank' rel='noreferrer'>
                       {child}
                   </a>
                </li>
            ))}
        </ul>
    </div>
  )
}

export default SocialLinks